<template>
  <div class="resultSns">
    <h4 class="resultSns__title">占い結果をシェアする</h4>
    <div class="snsBtns">
      <a :href="twitterLinkStr" target="_blank" class="snsBtns__btn snsBtns__btn--twitter">
        <img src="/static/img/common/sns_icon_twitter.svg" width="19" class="snsBtns__img snsBtns__img--twitter">ツイート
      </a>
      <a :href="lineLinkStr" target="_blank" class="snsBtns__btn snsBtns__btn--line">
        <img src="/static/img/common/sns_icon_line.svg" width="27" class="snsBtns__img snsBtns__img--line">LINEで送る
      </a>
      <a :href="facebookLinkStr" target="_blank" class="snsBtns__btn snsBtns__btn--facebook">
        <img src="/static/img/common/f_logo_RGB-White_250.png" width="19" class="snsBtns__img snsBtns__img--facebook">シェア
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "resultSns",
  data() {
    return {}
  },
  props: {
    shareLineData: {
      type: String,
      default() {
        return ''
      }
    },
    shareTwitterData: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    topUrl(){
      return 'https://www.uranai.tv/2021_luck'
    },
    twitterLinkStr() {
      return `http://twitter.com/share?url=${ this.topUrl }?cpno=990000000112&text=${ this.shareTwitterData }%0a` //要CPNO変更
    },
    lineLinkStr() {
      return `http://line.me/R/msg/text/?${ this.shareLineData }%0a${ this.topUrl }?cpno=990000000113` //要CPNO変更
    },
    facebookLinkStr() {
      return `http://www.facebook.com/share.php?u=${ this.topUrl }?cpno=990000000114` //要CPNO変更
    }
  }
}
</script>

<style scoped lang="scss">
.resultSns {
  max-width: 380px;
  margin: 0 auto;
  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 1px;
    color: #32373F;
    margin-bottom: 20px;
  }
}
.snsBtns {
  display: flex;
  justify-content: space-around;
  &__btn {
    display: block;
    border-radius: 5px;
    max-width: 180px;
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    padding: 0;
    height: 35px;
    line-height: 35px;
    text-align: center;
    text-decoration: none;
    flex: 1 1 auto;
    margin-right: 3.07%;
    &:last-child {
      margin-right: 0;
    }
    &--twitter { background: #1fa0f2; }
    &--line { background: #00b901; }
    &--facebook { background: #1877f2;}
  }
  &__img {
    vertical-align: middle;
    margin: -3px 6px 0 0;
    &--twitter { }
    &--line { margin-left: -3px; }
    &--facebook { }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/resultSns.vue